import axios from "axios";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { Facebook, HandCheck, Instagram, Linkedin } from "../../assets";
import dayjs from "dayjs";
import { useRouter } from "next/router";
import { timeConvert } from "../../utils/helpers";
import Recipe from "../Recipe/Recipe";

export default function DiscoverBeneBono({ posts, isRecipe }) {
	const router = useRouter();

	const handleClick = () => {
		router.push('/checkout');
	};

	const [userEmail, setUserEmail] = useState("");
	const [isEmpty, setIsEmpty] = useState(false);
	const [isSend, setIsSend] = useState(false);

	const [lang, setLang] = useState("");
	const { t } = useTranslation();

	useEffect(() => {
		const topLevelDomain = window.location.hostname.split(".").pop();
		setLang(topLevelDomain === "es" ? "es" : "fr");
	}, []);

	const susbcriptionNewsLetter = () =>
		axios
			.post("https://eo2uod9d6ddkieu.m.pipedream.net", {
				userEmail,
				lang,
			})
			.then((res) => {
				if (res) {
					setIsSend(true);
				}
			})
			.catch((error) => {
				console.log(error);
			});

	function handleChange(e) {
		setUserEmail(e.target.value);
	}

	return (
		<div className={isRecipe ? "discover_container_recipe" : "discover_container"}>
			{isRecipe && <p className="discover_recipe_slug_title">{t("discover.recipe.slug.title")}</p>}
			{isRecipe ?
				<div className="carousel">
					<div className="carousel__track">
						{posts.map((r, i) => (
							<div className="carousel__slide" key={i}>
								<Link
									href={`/recipes/${r.attributes.slug}`}
									className="carousel__link"
								>
									<Recipe
										imageUrl={
											r.attributes?.preview_image?.data[0]?.attributes?.url
												? `${r.attributes?.preview_image?.data[0]?.attributes?.url}`
												: "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
										}
										tags={r.attributes.season_tags.data}
										title={r.attributes.title}
										difficulty={r?.attributes.recipe_difficulty?.data[0]?.attributes?.name}
										duration={
											r?.attributes.duration < 60
												? `${r?.attributes.duration}min`
												: timeConvert(r?.attributes.duration)
										}
										regimeTags={r.attributes.dietTag.data}
									/>
								</Link>
							</div>
						))}
					</div>
				</div>
				:
				<div className="discover_article_selection">
					<p className="discover_article_selection_title">{t("selection.blog.desktop2")}</p>
					{posts.map((post, i) => {
						const tag = post.attributes.tags.data.map((t) => t.attributes.name);
						return (
							<Link href={`/blog/${post.attributes.slug}`} key={i} className="selection_blog_posts_article_card_container">
								<div className="selection_blog_posts_articles_image_container">
									<img src={post.attributes.preview_image.data[0].attributes.url} />
								</div>
								<div className="selection_blog_posts_article_card_details">
									<p className="selection_blog_posts_title">{post.attributes.title}</p>
									<div className="articles_tags_container_selection_blog_posts">
										<div className="articles_tags_selection_blog_posts">
											<p>{tag}</p>
										</div>
									</div>
									<div className="selection_blog_posts_author_and_date_container">
										<p className="selection_blog_posts_author">écrit par <b>{post.attributes.author}</b></p>
										<p className="selection_blog_posts_date">{dayjs(post.attributes.publishedAt).format("DD MMMM YYYY")}</p>
									</div>
								</div>
							</Link>
						)
					})}
					<div className="discover_article_selection_button">
						<p>Voir tous les articles</p>
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
							<path d="M9.6998 17.8C9.51647 17.6167 9.4248 17.3834 9.4248 17.1C9.4248 16.8167 9.51647 16.5834 9.6998 16.4L13.5998 12.5L9.6998 8.60005C9.51647 8.41672 9.4248 8.18338 9.4248 7.90005C9.4248 7.61672 9.51647 7.38338 9.6998 7.20005C9.88314 7.01672 10.1165 6.92505 10.3998 6.92505C10.6831 6.92505 10.9165 7.01672 11.0998 7.20005L15.6998 11.8C15.7998 11.9 15.8708 12.0084 15.9128 12.125C15.9541 12.2417 15.9748 12.3667 15.9748 12.5C15.9748 12.6334 15.9541 12.7584 15.9128 12.875C15.8708 12.9917 15.7998 13.1 15.6998 13.2L11.0998 17.8C10.9165 17.9834 10.6831 18.075 10.3998 18.075C10.1165 18.075 9.88314 17.9834 9.6998 17.8Z" fill="#272100" />
						</svg>
					</div>
				</div>
			}
			<div className="discover_section_benebono_newsletter_container">
				<p className="discover_section_desktop_newsletter_title">{t("newsletter.title")}</p>
				<p className="discover_section_desktop_newsletter_desc">{t("newsletter.description")}</p>
				{!isSend ? (
					<>
						<input className="discover_section_desktop_newsletter_input" type="email" onChange={handleChange} placeholder="miam@benebono.fr" />
						<div className="discover_section_newsletter_button_container">
							<div className="discover_section_newsletter_button" style={{ cursor: 'pointer' }} onClick={() => {
								if (userEmail) {
									susbcriptionNewsLetter();
								}
								if (!userEmail) {
									setIsEmpty(true);
								}
							}}>
								<p>{t("newsletter.button")}</p>
							</div>
						</div>
					</>
				) : (
					<>
						<div className="discover_section_desktop_newsletter_success_newsletter">
							<HandCheck />
							<p>{t("newsletter.already.subscribe")}</p>
						</div>
					</>
				)}

			</div>
			<div className={isRecipe ? "discover_section_explanation_recipe_container" : "discover_section_explanation_container"}>
				<p className="discover_section_explanation_title">
					{t("discover.about.bb")}
				</p>
				<div className="discover_section_explanation_card_container">
					<div className="discover_section_explanation_card">
						<img src="/discoverExplanation1.png" />
						<div className="discover_section_explanation_card_details">
							<div className="discover_section_explanation_card_details_title_container">
								<img src="/discoverExplanationIcon1.png" />
								<p className="discover_section_explanation_card_details_title">{t("discover.about.eco")}</p>
							</div>
							<p className="discover_section_explanation_card_details_desc">{t("discover.about.eco.desc")}</p>
						</div>
					</div>
					<div className="discover_section_explanation_card">
						<img src="/discoverExplanation2.png" />
						<div className="discover_section_explanation_card_details">
							<div className="discover_section_explanation_card_details_title_container">
								<img src="/discoverExplanationIcon2.png" />
								<p className="discover_section_explanation_card_details_title">{t("discover.about.pra")}</p>
							</div>
							<p className="discover_section_explanation_card_details_desc">{t("discover.about.pra.desc")}</p>
						</div>
					</div>
					<div className="discover_section_explanation_card">
						<img src="/discoverExplanation3.png" />
						<div className="discover_section_explanation_card_details">
							<div className="discover_section_explanation_card_details_title_container">
								<img src="/discoverExplanationIcon3.svg" />
								<p className="discover_section_explanation_card_details_title">{t("discover.about.resp")}</p>
							</div>
							<p className="discover_section_explanation_card_details_desc">{t("discover.about.resp.desc")}</p>
						</div>
					</div>
					<div className="discover_section_explanation_card">
						<img src="/discoverExplanation4.png" />
						<div className="discover_section_explanation_card_details">
							<div className="discover_section_explanation_card_details_title_container">
								<img src="/discoverExplanationIcon4.svg" />
								<p className="discover_section_explanation_card_details_title">{t("discover.about.bon")}</p>
							</div>
							<p className="discover_section_explanation_card_details_desc">{t("discover.about.bon.desc")}</p>
						</div>
					</div>
				</div>
				<div className="discover_section_explanation_cta" onClick={handleClick} style={{ cursor: "pointer" }}>
					<p>{t("discover.about.button.cta")}</p>
					<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
						<path d="M10.2 17.9167C10.0167 17.7334 9.92505 17.5001 9.92505 17.2167C9.92505 16.9334 10.0167 16.7001 10.2 16.5167L14.1 12.6167L10.2 8.71675C10.0167 8.53341 9.92505 8.30008 9.92505 8.01675C9.92505 7.73341 10.0167 7.50008 10.2 7.31675C10.3834 7.13341 10.6167 7.04175 10.9 7.04175C11.1834 7.04175 11.4167 7.13341 11.6 7.31675L16.2 11.9167C16.3 12.0167 16.371 12.1251 16.413 12.2417C16.4544 12.3584 16.475 12.4834 16.475 12.6167C16.475 12.7501 16.4544 12.8751 16.413 12.9917C16.371 13.1084 16.3 13.2167 16.2 13.3167L11.6 17.9167C11.4167 18.1001 11.1834 18.1917 10.9 18.1917C10.6167 18.1917 10.3834 18.1001 10.2 17.9167Z" fill="#272100" />
					</svg>
				</div>
			</div>
		</div>
	);
}
